import { Card, Select, Typography } from 'antd'
import { t } from 'i18next'
import React, { useContext } from 'react'
import { Color } from '../../../Common/Color'
import SpecialistContext from '../SpecialistContext'

export default function SpecialistReason ({ selectSpecialist, selectReason, width }) {
  const { reason, specialists, reasons, specialist } = useContext(SpecialistContext)

  return (
    <Card style={{ backgroundColor: Color.green, boxShadow: '1px 1px 10px #4f5d75', padding: '0 1em 2em 1em', width: '-webkit-fill-available', maxWidth: width }} variant='borderless'>
      <Typography.Title level={2} style={{ marginBottom: '3em', marginTop: '0', color: Color.white, textAlign: 'center' }}>{t('Public.Specialist.appointmentSelection')}</Typography.Title>
      <Typography.Title level={5} style={{ color: Color.white }}>{t('Public.Specialist.selectReason')}</Typography.Title>
      <Select onChange={selectReason} style={{ width: '-webkit-fill-available' }} defaultValue={reason?.id}>
        {
          reasons.map((reason) => (
            <Select.Option key={reason.id} value={reason.id}>
              {reason.name}
            </Select.Option>
          ))
        }
      </Select>
      <Typography.Title level={5} style={{ color: Color.white }}>{t('Public.Specialist.selectSpecialist')}</Typography.Title>
      <Select placeholder={t('Public.Specialist.automatic')} onChange={selectSpecialist} style={{ width: '-webkit-fill-available' }} allowClear value={specialist?.id}>
        {
          specialists && specialists.map((specialist) => (
            <Select.Option key={specialist.id} value={specialist.id}>
              {specialist.name}
            </Select.Option>
          ))
        }
      </Select>
    </Card>
  )
}
